import { ApolloClient, HttpLink, ApolloLink, InMemoryCache } from "@apollo/client"
import { onError } from "@apollo/client/link/error"

const GRAPHQL_URL = process.env.REACT_APP_API

const cache = new InMemoryCache()

// localStorage 토큰 저장 (새 창/탭에서도 인증 유지)
export const setToken = (token: string | null) => { token ? localStorage.setItem("token", token) : localStorage.removeItem("token") }
export const getToken = () => localStorage.getItem("token")
export const clearToken = () => { localStorage.removeItem("token") }

const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]))
    return payload.exp * 1000 < Date.now()
  } catch {
    return true
  }
}

const forceLogout = () => {
  clearToken()
  localStorage.removeItem("groupId")
  localStorage.removeItem("regionCode")
  localStorage.removeItem("username")
  localStorage.removeItem("authority")
  window.location.href = "/login"
}

const authLink = new ApolloLink((operation, forward) => {
  const token = getToken()

  if (token && isTokenExpired(token)) {
    forceLogout()
    return forward(operation)
  }

  operation.setContext(({ headers }) => ({
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  }))

  return forward(operation)
})

const errorHandlelink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path, extensions }) => {
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      if (extensions?.code === "UNAUTHENTICATED" || message.includes("401")) {
        forceLogout()
      }
    })
  }
  if (networkError) {
    console.log(`[Network error]: ${networkError}`)
    if ("statusCode" in networkError && (networkError as any).statusCode === 401) {
      forceLogout()
    }
  }
})

export const createClient = (eventLink?: ApolloLink) => {
  const _eventLink = eventLink ? [eventLink] : []

  return new ApolloClient({
    cache,
    devtools: { enabled: process.env.NODE_ENV === "development" },
    link: ApolloLink.from([..._eventLink, errorHandlelink, authLink, new HttpLink({ uri: GRAPHQL_URL, credentials: "same-origin" })]),
  })
}
